module.exports = __webpack_public_path__ + "81bfc90260084b21f5f0ad0fb1c69fec.jpg";